<template>
  <div class="refund">
    <div class="section" v-loading="loading">
      <div class="section-content">
        <p class="title">REFUND AND CANCELLATION</p>
        <p>
          Cancellation Policy
        </p>
        <p>
          Transactions to transfer money to your rummy cash account have to be made through third-party payment 
          gateways. The Company is not responsible for the denial or rejection of any transactions as they are 
          subject to the terms and conditions of the third-party payment gateways. The Company may reverse any 
          transactions, and the specific amount will in such a case be refunded to the financial instrument/platform 
          that was used by you to perform the transaction.
        </p>
        <p>
          Refund Policy
        </p>
        <p>
          The Company can its sole discretion process refunds to you under the following circumstances: 
          Erroneous/Accidental transactions - transaction amount unutilized: In case of an accidental/ erroneous 
          cash credit or other similar event, you may request for a refund of such Cash Credit transaction ("Refund")
          within 2 weeks of initiating such transaction. The Company, after determining in its sole discretion 
          whether such Refund request is genuine, and that you have the requisite corresponding Cash Balance in your 
          Accounts, will process the Refund request within 2 weeks. Any Refund will be carried out only to the 
          instrument which was used to carry out the corresponding Cash Credit transaction, and no requests for an 
          alternate mode of Refund will be entertained under any circumstances.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  }
  // mounted() {
  //   this.$http
  //     .all([
  //       this.$http.get("Honor/GetHonorAll"),
  //       this.$http.get("Enterprise/GetEnterpriseAll"),
  //       this.$http.get(`Team/GetTeamAll`),
  //       this.$http.get(`Course/GetCourseAll`)
  //     ])
  //     .then(
  //       this.$http.spread(
  //         (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
  //           this.honorList = responseHonor.data;
  //           this.partnerImg = responseEnterprise.data;
  //           this.teamItem = responseTeam.data;

  //           var groupCount = Math.ceil(responseCourse.data.length / 2);
  //           window.console.log(groupCount);
  //           for (let i = 0; i < groupCount; i++) {
  //             let img2 = [];
  //             for (let j = 0; j < 2; j++) {
  //               if (responseCourse.data.length - 1 >= i * 2 + j) {
  //                 img2.push(responseCourse.data[i * 2 + j]);
  //               }
  //             }
  //             this.courseList.push(img2);
  //           }
  //           window.console.log(this.courseList);
  //           this.loading = false;
  //         }
  //       )
  //     );
  // }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.refund {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 62%;
    margin-left: 19%;
    font-family: PingFangSC-Regular;
    font-size: 20px;
    letter-spacing: 0;
    font-weight: 400;
    
    &-content {

      .title {
        width: 100%;
        font-size: 24px;
        text-align: center;
        margin-top: 26px;
        margin-bottom: 20px;
      }
      .p2 {
        margin: 15px 0;
      }
      
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>